const createTab = (label: string, value: string, active = false, access = ["1", "2", "3", "4"]) => ({
    label,
    number_of_records: 0,
    active,
    value,
    access
});

export const TABS = {
    "active": createTab("Active", "active", true),
    "upcoming": createTab("Upcoming", "upcoming"),
    "completed": createTab("Completed", "completed"),
    "cancelled": createTab("Cancelled", "cancelled"),
    "draft": createTab("Draft", "draft", false, ["1", "2"])
};
